import Cookies from 'js-cookie';

export const CLEAR_LICENSE_EDIT = 'kopaprolicense/licenseEdit/clearLicenseEdit'
export const UPDATE_LICENSE_EDIT = 'kopaprolicense/licenseEdit/updateLicenseEdit'
export const ASYNC_SAVE_LICENSE = 'kopaprolicense/licenseEdit/asyncSaveLicense'
export const SAVE_LICENSE_SUCCESS = 'kopaprolicense/licenseEdit/saveLicenseSuccess'
export const ASYNC_READ_LICENSE = 'kopaprolicense/licenseEdit/asyncReadLicense'
export const READ_LICENSE_SUCCESS = 'kopaprolicense/licenseEdit/readLicenseSuccess'
export const ASYNC_CHECK_AMT = 'kopaprolicense/licenseEdit/asyncCheckAmt'
export const CHECK_AMT_SUCCESS = 'kopaprolicense/licenseEdit/checkAmtSuccess'
export const ASYNC_ADD_LICENSEPAY = 'kopaprolicense/licenseEdit/asyncAddLicensePay'
export const ADD_LICENSEPAY_SUCCESS = 'kopaprolicense/licenseEdit/addLicensePaySuccess'

export const initialState = {   
    code:'',
    desc:'',
    plan:'su',
    support:'hotline',
    years:1,
    months:1,
    cur:'HKD',
    amt:0,
    couponCode:'',
    netAmt:0,
    irev:0,
    activationCode:'',
    merchantOption:{},
    createDate: new Date(),
    expDate: new Date(),
    licensePayments: [],
    licenseTasks: [],
    newPlan:'su',
    newSupport:'noHotline',
    residue:0,
    residueCur:"HKD",
    monthMode:'false',
    status:'pending',
    systemTime: getSysDate(),
    trialExtended:false,
    isTrial:false,
    planChangeDate: getSysDate(),    
    refCode:'',
    internal: 'false'
}

function getSysDate(){
    let sysTime = Cookies.get('systemTime') ||  new Date();
    let myDate = new Date(sysTime);    
    return myDate;
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
    case UPDATE_LICENSE_EDIT:        
        {
            let newstate =  {
            ...state,
            ...payload
        }                 
        if(newstate.monthMode === 'true' && newstate.monthMode != state.monthMode){
            newstate.months = 1;
        }

        if(newstate.monthMode !== 'true' && newstate.monthMode != state.monthMode){
            newstate.years = 1;
        }

        if(newstate.newPlan !== 'et'){          
            newstate.newSupport = 'noHotline';
        }
        //console.log(newstate.years);
        return newstate;
    }
    case CLEAR_LICENSE_EDIT:        
        return{
            ...initialState,
            systemTime: getSysDate()
        }
    case READ_LICENSE_SUCCESS:{
        let newstate =  {
            ...state,
            ...payload,
            
        }  

        if( newstate.months > 0 ){
            newstate.monthMode = 'true';
        }else{
            newstate.monthMode = 'false';
        }
        newstate.newPlan = newstate.plan;
        newstate.newSupport = newstate.support;        
        newstate.systemTime = getSysDate();
        return newstate;
    }
    case CHECK_AMT_SUCCESS:
        return{
            ...state
            // amt: payload.amt,
            // netAmt: payload.netAmt
        }
    case SAVE_LICENSE_SUCCESS:
        return {
            ...state,
            ...payload
        }
    default:
        return state
    }
}

export const clearLicenseEdit = () => ({
    type: CLEAR_LICENSE_EDIT
})

export const updateLicenseEdit = (data) => ({
    type: UPDATE_LICENSE_EDIT, payload: data
})

export const saveLicenseEdit = (callback,editMode,trial,extendTrial) => ({
    type: ASYNC_SAVE_LICENSE, payload: {
        callback: callback,
        editMode: editMode,
        trial:trial,
        extendTrial: extendTrial
    }
})

export const readLicense = (code,callback) => ({
    type: ASYNC_READ_LICENSE, payload:{
        code: code,
        callback: callback
    }
})

export const checkLicenseAmt = (callback,editMode) => ({
    type: ASYNC_CHECK_AMT, payload: {
        callback: callback,
        editMode: editMode        
    }
})

export const addLicensePay = (callback, uuid, paymentMethod) => ({
    type: ASYNC_ADD_LICENSEPAY, payload: {
        callback: callback,
        uuid:uuid,
        paymentMethod
    }
})
